export const searchDropdown =  [
	{
	  title: "Product Name (SKU)",
	  value: "productName"
	},
	{
	  title: "Description",
	  value: "productDescription"
	},
	{
	  title: "UPC",
	  value: "upc"
	},
	{
	  title: "Classification",
	  value: "itmProductClass"
	},
	{
	  title: "Variant Type",
	  value: "variantAttributeType"
	},
	{
	  title: "Variant Value",
	  value: "variantAttributeValue"
	},
	{
	  title: "Sub Category",
	  value: "itmSubCategory"
	},
	{
	  title: "Model Number",
	  value: "itmModel"
	 },
	 {
	  title: "Size",
	  value: "itmSize"
	 },
	 {
	  title: "Color",
	  value: "itmColor"
	 },
	 {
	  title: "Style",
	  value: "itmStyle"
	 }
]



// WEBPACK FOOTER //
// ./src/pages/products/filter/searchDropdown.js